import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
// import { Redirect } from "react-router-dom";
import { login3 } from "../../actions";
import { getIsAuthenticated, getInitAppSuccess } from "../../reducers";
import DotLoader from "../Loaders/DotLoader";
import styled from "styled-components";
import qs from "qs";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const LoginIDPHub = (props) => {
  const { login3 } = props;

  const { search } = location;

  const queryParams = useMemo(
    () => qs.parse(search, { ignoreQueryPrefix: true }),
    [search]
  );

  useEffect(() => {
    login3({ props: { token: queryParams.token } });
  }, [login3]);

  return (
    <Wrapper>
      <DotLoader />
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: getIsAuthenticated(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login3: ({ orgId, props }) => {
      dispatch(login3({ orgId, props, strategy: "idphub" }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginIDPHub);
